let paymentFormsApi = {
    async get(token, companyId, params = {}) {
        let response = await window.axios.get('/api/payment-forms', {
            params: {
                api_token: token,
                company_logged: companyId,
                ...params
            }
        });
        return response.data;
    },
    async delete(token, companyId, id) {
        let response = await window.axios.delete('/api/payment-forms/' + id, {
            params: {
                api_token: token,
                company_logged: companyId,
            }
        });
        return response.data;
    },
    async save(token, companyId, data) {
        let response = await window.axios.post('/api/payment-forms', {
            api_token: token,
            company_logged: companyId,
            company_id: companyId,
            ...data
        });
        return response.data;
    }
};

export default paymentFormsApi;

